import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      imgWidth: 0,
      //图片宽度
      divLeft: 0,
      parentTop: 0,
      // 父级距离顶部的高度
      divTop: 0,
      //内部距离顶部的高度
      valueList: [],
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      width1: 0,
      height1: 0
    };
  },
  props: {
    srcUrl: {
      type: String,
      default: ''
    },
    edit: {
      type: Boolean,
      default: true
    },
    axis: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    image_height: {},
    //图片原始宽度高度
    image_width: {}
  },
  watch: {
    axis: {
      handler: function handler(newValue, oldValue) {
        var _this = this;

        debugger;
        this.$nextTick(function () {
          _this.imgWidthData();
        });
      },
      deep: true
    },
    srcUrl: function srcUrl(newValue, oldValue) {
      var _this2 = this;

      var img = new Image(); // 改变图片的src

      img.src = newValue; // 加载完成执行

      img.onload = function () {
        // 打印
        _this2.width = img.height;
        _this2.height = img.width; // console.log('imgw:',w,',imgh:',h);

        _this2.imgWidthData(); // //图片的宽度
        // this.width=img.width
        // this.width1=img.width
        // this.x=this.axis[0].x
        // this.y=this.axis[0].y
        // console.log('width:'+img.width+',height:'+img.height);
        // // 获取100%的宽度与高度
        // this.imgWidthData()

      };
    }
  },
  methods: {
    /**
     * 获取100%时的图片宽度数据
     */
    imgWidthData: function imgWidthData() {
      this.valueList.splice(0);
      var imgEl = document.getElementById("imgContent");
      var imgE3 = document.getElementById("imageContent");
      this.width1 = imgEl.offsetWidth;

      if (this.width) {
        this.height1 = this.width1 * this.width / this.height;
        console.log('w:', this.width1);
        console.log('h:', this.height1);

        for (var i in this.axis) {
          var x = this.axis[i].x * this.width1 / this.image_width;
          var y = this.axis[i].y * this.height1 / this.image_height;
          console.log(x, y);
          this.valueList.push({
            x: x,
            y: y,
            name: this.axis[i].name,
            check: this.axis[i].check
          });
        }
      }
    },

    /**
     * 监听图片的滚动条滚动，并计算距离顶部的调试
     */
    scrool: function scrool(event) {
      var targetObje = event.target;
      var top = targetObje.scrollTop;

      if (targetObje.className.indexOf('imgContent') > -1 || targetObje.className.indexOf('imageContent') > -1) {
        this.divTop = top;
        this.divLeft = targetObje.scrollLeft; // console.log('divTop:'+this.divTop)
        // console.log(this.divLeft)

        for (var i in this.valueList) {// this.$set(this.valueList[i],'y',this.valueList[i].y-this.divTop)
        }
      } else {
        this.parentTop = top; // console.log("父级高度："+this.parentTop)
      }
    },
    // 找到元素的屏幕位置
    locationLeft: function locationLeft(element) {
      var offsetTotal = element.offsetLeft;
      var scrollTotal = 0; // element.scrollLeft but we dont want to deal with scrolling - already in page coords

      if (element.tagName != "BODY") {
        if (element.offsetParent != null) return offsetTotal + scrollTotal + this.locationLeft(element.offsetParent);
      }

      return offsetTotal + scrollTotal;
    },
    // 找到元素的屏幕位置
    locationTop: function locationTop(element) {
      var offsetTotal = 0;

      if (element.offsetTop) {
        offsetTotal = element.offsetTop;
      }

      var scrollTotal = 0; // element.scrollTop but we dont want to deal with scrolling - already in page coords

      if (element.tagName != "BODY") {
        if (element.offsetParent != null) return offsetTotal + scrollTotal + this.locationTop(element.offsetParent);
      }

      return offsetTotal + scrollTotal;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {// this.imgWidthData()
    });
    window.addEventListener('scroll', this.scrool, true);
  }
};